import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import pages from "../../../constants/pages";
import { validationSchema } from "./groupObject";

export default function Form({ editState, setEditState, formData }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnMount
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        var priority;
        // axios({
        //   url: "/list/fieldsGroups",
        //   disableRedirect: true,
        // }).then((response) => {
        //   if (response.status) {
        //     priority = response.data.length;
        axios({
          url: "/save/group",
          method: "POST",
          disableRedirect: true,
          data: {
            category_name: formData.categoryName,
            category_title: formData.categoryTitle,
          },
        }).then((response) => {
          if (response.status) {
            setEditState(false);
            navigate(pages.groupListPage.route);
            dispatch(
              alert({
                message: response.message.displayMessage,
                type: "success",
              })
            );
          }
          //   });
          // }
        });
        setSubmitting(false);
      }}
    >
      {(formikProps) => (
        <form onSubmit={formikProps.handleSubmit}>
          <FormDisplay
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </form>
      )}
    </Formik>
  );
}
